import * as Yup from 'yup';
import { validateField, ValidationType } from './formValidation';
import { getLanguageScoreRange } from 'utils/v2/visaApplication';

// Conditional validation for score fields based on test_type
const scoreValidation = Yup.number()
    .nullable()
    .when('test_type', {
        is: (value: string) => !!value,
        then: (schema) =>
            schema.test(
                'score-range',
                'Score is out of valid range for the selected test type',
                function (value) {
                    if (value === null || value === undefined) {
                        return true;
                    }
                    const { min, max } = getLanguageScoreRange(this.parent.test_type);
                    return value >= min && value <= max;
                }
            ),
        otherwise: (schema) => schema.nullable(),
    });

/** Native language entries use level === 5 and auto-filled scores. */
const isNativeLanguage = (level: number | null | undefined) => level === 5;

const languageEntrySchema = Yup.object({
    language: validateField(ValidationType.STRING),
    // Native language auto-sets test_type; proficiency rows require it.
    test_type: Yup.string()
        .nullable()
        .when('level', {
            is: isNativeLanguage,
            then: (schema) => schema.nullable(),
            otherwise: (schema) =>
                schema.required('Test type is required').min(1, 'Test type is required'),
        }),
    level: Yup.number().nullable(),
    listening: scoreValidation,
    reading: scoreValidation,
    speaking: scoreValidation,
    writing: scoreValidation,
    spouse_id: Yup.number().nullable(),
    test_date: Yup.mixed().nullable(),
    user_id: Yup.number().nullable(),
});

const spouseLanguageEntrySchema = Yup.object({
    language: validateField(ValidationType.STRING),
    test_type: validateField(ValidationType.STRING),
    level: Yup.number().nullable(),
    listening: scoreValidation,
    reading: scoreValidation,
    speaking: scoreValidation,
    writing: scoreValidation,
    spouse_id: Yup.number().nullable(),
    test_date: Yup.mixed().nullable(),
    user_id: Yup.number().nullable(),
});

export const languageSchema = Yup.object({
    user_languages: Yup.array()
        .of(languageEntrySchema)
        .min(1, 'At least one language proficiency entry is required'),
    spouse_languages: Yup.array().of(spouseLanguageEntrySchema),
});
